import { render, staticRenderFns } from "./ProjectActionsCreate.vue?vue&type=template&id=8c8c8bd6&lang=pug&"
import script from "./ProjectActionsCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectActionsCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActionsCreate.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports